var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-row"},[_c('img',{staticClass:"icon-row-image",attrs:{"src":_vm.getImage()}}),_c('p',{staticClass:"icon-row-text",domProps:{"innerHTML":_vm._s(this.$sanitize(_vm.text))}})])}
var staticRenderFns = []

export { render, staticRenderFns }